import { render } from "./EditAttributeView.vue?vue&type=template&id=6f8372d4"
import script from "./EditAttributeView.vue?vue&type=script&lang=js"
export * from "./EditAttributeView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kokleng/Documents/old_macbook/document/Dollar/core_system/from_gitlab/pos-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__